// extracted by mini-css-extract-plugin
export var workBox = "WorkBox-module--workBox--K8wwa";
export var workBoxChild = "WorkBox-module--workBoxChild--qaDJk";
export var workYear = "WorkBox-module--workYear--IjZwk";
export var workLinks = "WorkBox-module--workLinks--Mx8MZ";